import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import OutsideClickHandler from "react-outside-click-handler"; 
const defaultItem = { dashboardName: "", description: "" };

const AddRenameModal: React.FC<any> = ({
  show = false,
  item = defaultItem,
  onSave,
  onClose,
  mode,
  isSubmitting,
}) => {
  const [name, setName] = useState(item?.dashboardName || "");
  const [description, setDescription] = useState(item?.description || "");
  const [templateId, setTemplateId] = useState(0);
  const [inputPosition, setInputPosition] = useState(0);
  const [error, setError] = useState("");

  const handleSave = () => {
    onSave({ ...item, dashboardName: name, description, templateId });
  };

  const handleBlur = (inputPos) => {
    if (inputPos == 1) {
      setName((prev) => prev.trim());
      if (name.trim() === "") {
        setError("Please Enter Dashboard Name");
      } else {
        setError("");
      }
    }

    setInputPosition(inputPos);
  };

  const handleTemplate = (id) => {
    setTemplateId(id);
  };

  const handleKeyDown = (e, id) => {
    if (e.key === "Enter" || e.key === " ") {
      handleTemplate(id);
    }
  };
  const content = (
    <div>
      <div className="dropdown-body">
        <Form>
          {mode == "add" && (
            <Form.Group>
              <Form.Label className="mb-3">
                Build your own or choose a template
              </Form.Label>
              <div className="list-buttons d-flex align-items-center">
                <div>
                  <Button
                    type="button"
                    // tabIndex={0}
                    className={`${templateId == 0 ? "active" : ""}`}
                    onClick={() => handleTemplate(0)}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="34"
                      height="35"
                      viewBox="0 0 34 35"
                      fill="none"
                    >
                      <path
                        d="M16.9987 0.770813C7.7987 0.770813 0.332031 8.23748 0.332031 17.4375C0.332031 26.6375 7.7987 34.1041 16.9987 34.1041C26.1987 34.1041 33.6654 26.6375 33.6654 17.4375C33.6654 8.23748 26.1987 0.770813 16.9987 0.770813ZM23.6654 19.1041H18.6654V24.1041C18.6654 25.0208 17.9154 25.7708 16.9987 25.7708C16.082 25.7708 15.332 25.0208 15.332 24.1041V19.1041H10.332C9.41537 19.1041 8.66537 18.3541 8.66537 17.4375C8.66537 16.5208 9.41537 15.7708 10.332 15.7708H15.332V10.7708C15.332 9.85415 16.082 9.10415 16.9987 9.10415C17.9154 9.10415 18.6654 9.85415 18.6654 10.7708V15.7708H23.6654C24.582 15.7708 25.332 16.5208 25.332 17.4375C25.332 18.3541 24.582 19.1041 23.6654 19.1041Z"
                        fill="#065A8C"
                      />
                    </svg>
                  </Button>
                  <h6>Build My Own</h6>
                </div>
                <div>
                  <Button
                    type="button"
                    // tabIndex={2}
                    className={`${templateId == 1 ? "active" : ""}`}
                    onClick={() => handleTemplate(1)}
                    onKeyDown={(e) => handleKeyDown(e, 1)}
                  >
                     <svg xmlns="http://www.w3.org/2000/svg" width="110" height="110" viewBox="0 0 110 110" fill="none">
                      <path d="M83 55C83 39.536 70.464 27 55 27C39.536 27 27 39.536 27 55C27 70.464 39.536 83 55 83C70.464 83 83 70.464 83 55Z" fill="#E5F5FF"/>
                      <path d="M70.0989 49.2917C67.6823 49.2917 66.3323 51.6917 66.8823 53.475L60.9656 59.4084C60.4656 59.2584 59.7323 59.2584 59.2323 59.4084L54.9823 55.1584C55.5489 53.375 54.1989 50.9584 51.7656 50.9584C49.3489 50.9584 47.9823 53.3584 48.5489 55.1584L40.9489 62.7417C39.1656 62.1917 36.7656 63.5417 36.7656 65.9584C36.7656 67.7917 38.2656 69.2917 40.0989 69.2917C42.5156 69.2917 43.8656 66.8917 43.3156 65.1084L50.8989 57.5084C51.3989 57.6584 52.1323 57.6584 52.6323 57.5084L56.8823 61.7584C56.3156 63.5417 57.6656 65.9584 60.0989 65.9584C62.5156 65.9584 63.8823 63.5584 63.3156 61.7584L69.2489 55.8417C71.0323 56.3917 73.4323 55.0417 73.4323 52.625C73.4323 50.7917 71.9323 49.2917 70.0989 49.2917Z" fill="#065A8C"/>
                      <path d="M60.0989 50.9584L61.6656 47.5084L65.0989 45.9584L61.6656 44.4084L60.0989 40.9584L58.5656 44.4084L55.0989 45.9584L58.5656 47.5084L60.0989 50.9584Z" fill="#065A8C"/>
                      <path d="M40.9323 54.2917L41.7656 50.9584L45.0989 50.125L41.7656 49.2917L40.9323 45.9584L40.0989 49.2917L36.7656 50.125L40.0989 50.9584L40.9323 54.2917Z" fill="#065A8C"/>
                      <mask id="mask0_29_46" style={{ maskType:'alpha'}} maskUnits="userSpaceOnUse" x="-6" y="-6" width="121" height="121">
                      <path d="M114.547 -5.4375H-5.45312V114.562H114.547V-5.4375Z" fill="url(#paint0_radial_29_46)"/>
                      <mask id="mask1_29_46" style={{ maskType:'alpha'}} maskUnits="userSpaceOnUse" x="-1" y="0" width="111" height="111">
                      <mask id="mask2_29_46" style={{ maskType:'luminance'}} maskUnits="userSpaceOnUse" x="-1" y="0" width="111" height="111">
                      <path d="M109.875 0.875H-0.125V110.875H109.875V0.875Z" fill="white"/>
                      </mask>
                      <g mask="url(#mask2_29_46)">
                      <path d="M114.422 -4.5625H-5.57812V115.438H114.422V-4.5625Z" fill="url(#paint1_radial_29_46)"/>
                      </g>
                      </mask>
                      <g mask="url(#mask1_29_46)">
                      <path d="M54.4219 90.9375C74.028 90.9375 89.9219 75.0436 89.9219 55.4375C89.9219 35.8314 74.028 19.9375 54.4219 19.9375C34.8158 19.9375 18.9219 35.8314 18.9219 55.4375C18.9219 75.0436 34.8158 90.9375 54.4219 90.9375Z" stroke="#EAECF0"/>
                      <path d="M54.4219 98.9375C78.4463 98.9375 97.9219 79.4619 97.9219 55.4375C97.9219 31.4131 78.4463 11.9375 54.4219 11.9375C30.3975 11.9375 10.9219 31.4131 10.9219 55.4375C10.9219 79.4619 30.3975 98.9375 54.4219 98.9375Z" stroke="#EAECF0"/>
                      <path d="M54.4219 106.938C82.8646 106.938 105.922 83.8802 105.922 55.4375C105.922 26.9948 82.8646 3.9375 54.4219 3.9375C25.9792 3.9375 2.9219 26.9948 2.9219 55.4375C2.9219 83.8802 25.9792 106.938 54.4219 106.938Z" stroke="#EAECF0"/>
                      </g>
                      </mask>
                      <g mask="url(#mask0_29_46)">
                      <path d="M54.5469 90.0625C74.153 90.0625 90.0469 74.1686 90.0469 54.5625C90.0469 34.9564 74.153 19.0625 54.5469 19.0625C34.9408 19.0625 19.0469 34.9564 19.0469 54.5625C19.0469 74.1686 34.9408 90.0625 54.5469 90.0625Z" stroke="#EAECF0"/>
                      <path d="M54.5469 98.0625C78.5713 98.0625 98.0469 78.5869 98.0469 54.5625C98.0469 30.5381 78.5713 11.0625 54.5469 11.0625C30.5225 11.0625 11.0469 30.5381 11.0469 54.5625C11.0469 78.5869 30.5225 98.0625 54.5469 98.0625Z" stroke="#EAECF0"/>
                      <path d="M54.5469 106.062C82.9896 106.062 106.047 83.0052 106.047 54.5625C106.047 26.1198 82.9896 3.0625 54.5469 3.0625C26.1042 3.0625 3.0469 26.1198 3.0469 54.5625C3.0469 83.0052 26.1042 106.062 54.5469 106.062Z" stroke="#EAECF0"/>
                      </g>
                      <defs>
                      <radialGradient id="paint0_radial_29_46" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(54.5469 54.5625) rotate(90) scale(60)">
                      <stop/>
                      <stop offset="1" stop-opacity="0"/>
                      </radialGradient>
                      <radialGradient id="paint1_radial_29_46" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(54.4219 55.4375) rotate(90) scale(60)">
                      <stop/>
                      <stop offset="1" stop-opacity="0"/>
                      </radialGradient>
                      </defs>
                      </svg>
                  </Button>
                  <h6>Key Metrics</h6>
                </div>
              </div>
            </Form.Group>
          )}
          <Form.Group controlId="dashboardName">
            <Form.Label>
              Dashboard Name <span>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Dashboard Name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setError("");
              }}
              // tabIndex={3}
              maxLength={50}
              className={error ? "error-invalid" : ""}
              onBlur={() => handleBlur(1)}
            />
            {error && inputPosition >= 1 && (
              <div className="error-message">{error}</div>
            )}
          </Form.Group>
          <Form.Group controlId="dashboardDescription" className="mt-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              // tabIndex={4}
              onBlur={() => handleBlur(2)}
              maxLength={100}
            />
          </Form.Group>
        </Form>
      </div>
      <div className="d-flex justify-content-end footer">
        <Button
          variant="outline"
          onClick={onClose}
          // tabIndex={5}
        >
          Cancel
        </Button>
        <Button
          disabled={!name.trim() || isSubmitting}
          onClick={handleSave}
          className="ms-2"
          // tabIndex={6}
        >
          {mode == "add" ? "Create" : "Save"}
        </Button>
      </div>
    </div>
  );

  return mode === "add" ? (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="create-dashboard-modal"
      autoFocus
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === "add" ? "Create Dashboard" : "Edit Dashboard"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
    </Modal>
  ) : (
    <OutsideClickHandler
      onOutsideClick={(e) => {
        onClose(); // Ensure this triggers the close action
      }}
    >
      <div className="border rounded edit-dashboard-dropdown">
        <div className="d-flex align-items-center dropdown-header">
          <button onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
            >
              <path
                d="M5.49961 0.5875C5.17461 0.2625 4.64961 0.2625 4.32461 0.5875L0.499609 4.4125C0.174609 4.7375 0.174609 5.2625 0.499609 5.5875L4.32461 9.4125C4.64961 9.7375 5.17461 9.7375 5.49961 9.4125C5.82461 9.0875 5.82461 8.5625 5.49961 8.2375L2.26628 4.99583L5.49961 1.7625C5.82461 1.4375 5.81628 0.904167 5.49961 0.5875Z"
                fill="#2CAF92"
              />
            </svg>
          </button>
          <h4>{mode === "add" ? "Create Dashboard" : "Edit Dashboard"}</h4>
        </div>
        {content}
      </div>
    </OutsideClickHandler>
  );
};

export default AddRenameModal;
